import React from 'react';

function ErrorScreen({ error }) {
  return (
    <div className="error-screen">
      <div className="error-content">
        <div className="error-icon">⚠</div>
        <h2>HUD Initialization Failed</h2>
        <p className="error-message">{error}</p>
        <button className="retry-btn" onClick={() => window.location.reload()}>
          Retry Connection
        </button>
        <p className="error-hint">
          If the problem persists, please check your connection or contact support.
        </p>
      </div>
    </div>
  );
}

export default ErrorScreen;